import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications.component';

import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';


import { NotificationsService } from './notifications.service';
import { MessageService } from 'primeng/api';

@NgModule({
    imports: [CommonModule, MessagesModule, MessageModule, NotificationsComponent],
    exports: [NotificationsComponent],
    providers: [NotificationsService, MessageService],
})
export class IdsNotificationsModule {}
